import { useReveal } from "@/hooks/useReveal";

// Wraps children with a gentle opacity + 18px rise reveal on scroll.
const Reveal = ({ children, className = "", as: Tag = "div", delay = 0, ...rest }) => {
  const [ref, visible] = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? "reveal-visible" : ""} ${className}`}
      style={{ transitionDelay: visible ? `${delay}ms` : "0ms" }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
